const ReviewsCategory = () => {
  const categoryCards = [...document.querySelectorAll(".category-reviews__category-card")];
  const relatedSections = [...document.querySelectorAll(".category-reviews__section")];

  if (categoryCards.length > 0) {
    categoryCards.forEach((categoryCard) => {
      categoryCard.addEventListener("click", () => {
        const cardId = categoryCard.getAttribute("data-id"); 

        categoryCards.forEach((card) => card.classList.remove("active"));
        relatedSections.forEach((section) => section.classList.remove("active"));

        categoryCard.classList.add("active");

        const relatedSection = relatedSections.find(section => section.getAttribute("data-id") === cardId);
        if (relatedSection) {
          relatedSection.classList.add("active");

          const sectionCloser = relatedSection.querySelector(".category-reviews__section-closer");
          if (sectionCloser) {
            sectionCloser.addEventListener("click", () => {
              categoryCard.classList.remove("active");
              relatedSection.classList.remove("active");
            });
          }
        }
      });
    });
  }
};

export default ReviewsCategory;
